module.exports = __webpack_public_path__ + "static/media/hackathon-of-humanoid-robots-1.99bcf439.png";